export interface SrRole {
    id: string;
    name: string;
    description: string;
}

export const EMPTY_SR_ROLE: SrRole = {
    id: '', name: '', description: ''
}